import { FC } from 'react';
import { getInitials } from '@/lib/helpers';
import { AvatarSize, getAvatarColor } from './helpers';
import Avatar from '.';

interface Props {
  identifier: string;
  size?: AvatarSize;
  tooltipOverride?: string;
  className?: string;
  hideTooltip?: boolean;
}

const UserAvatar: FC<Props> = ({
  identifier,
  size = 'x-small',
  tooltipOverride,
  className,
  hideTooltip = false,
}) => {
  const initials = getInitials(identifier);
  const avatarColor = getAvatarColor(identifier);

  const tooltipContent = !hideTooltip ? tooltipOverride || identifier : undefined;

  return (
    <Avatar
      label={initials}
      size={size}
      backgroundColor={avatarColor}
      tooltip={tooltipContent}
      className={className}
    />
  );
};

export default UserAvatar;
